import React from "react";

const Dropdown = ({
  id,
  label,
  value,
  onChange,
  options,
  defaultOption,
  error,
}) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium mb-2">
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={onChange}
        className="w-full p-2 border border-gray-300 rounded-md h-12 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
      >
        <option value="">{defaultOption}</option>
        {options.map((option, index) =>
          typeof option === "object" ? (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ) : (
            <option key={index} value={option}>
              {option}
            </option>
          )
        )}
      </select>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default Dropdown;
